import { Department } from './Model/Department';
import { StaticSettings } from './StaticSettings';

interface JobCenterEnv {
    departmentId: string;
    department: Partial<Department>;
    jobVacancyFormUri: string;
    candidateFormUri: string;
    baseUrl: string;
    basePath: string;
    twoLetterIsoCode: string;
}

interface JobCenterEnvWindow {
    JobCenterEnv: JobCenterEnv;
}

export class Config {
    public static fromEnv(): Config {
        const options: JobCenterEnv = ((window as unknown as JobCenterEnvWindow)['JobCenterEnv'] || {}) as JobCenterEnv;

        const department = options.department ? Department.fromData(options.department) : undefined;

        return new Config(
            department,
            options.jobVacancyFormUri || '',
            options.candidateFormUri || '',
            options.basePath || '',
            options.baseUrl || '',
            options.twoLetterIsoCode || '',
        );
    }

    constructor(
        public readonly department: Department | undefined,
        public readonly jobVacancyFormUri: string,
        public readonly candidateFormUri: string,
        public readonly basePath: string,
        public readonly baseUrl: string,
        public readonly twoLetterIsoCode: string
    ) {
    }

    get departmentId(): string {
        const department = this.department;
        if (StaticSettings.limitToDepartment && department) {
            return department.referenceId;
        } else {
            return '';
        }
    }

    // get basePath(): string {
    //     console.error('mamama');
    //     return `${process.env.PUBLIC_URL}`;
    // }

    get version(): string {
        return `${process.env.REACT_APP_VERSION}`;
    }

    get isDevelopmentEnv(): boolean {
        return process.env.NODE_ENV === 'development';
    };
}

